import React from 'react';

function PapuaNewGuinea(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124026)">
        <mask
          id="mask0_800_124026"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124026)">
          <rect width="36" height="24" rx="2" fill="#E11C1B" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0L36 24H0V0Z"
            fill="#1D1D1D"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.96875 18.2685H9.46705L10.1796 16.7752L11.0172 18.2584L12.5522 18.333L11.2403 19.6023L11.9139 21.1314L10.2464 20.2802L8.70651 21.139L9.28739 19.6543L7.96875 18.2685Z"
            fill="#EEEEF6"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.46875 14.2685H4.96705L5.67961 12.7752L6.51715 14.2584L8.05224 14.333L6.74033 15.6023L7.41394 17.1313L5.74639 16.2802L4.20651 17.139L4.78739 15.6543L3.46875 14.2685Z"
            fill="#EEEEF6"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.96875 12.2685H9.46705L10.1796 10.7752L11.0172 12.2584L12.5522 12.333L11.2403 13.6023L11.9139 15.1314L10.2464 14.2802L8.70651 15.139L9.28739 13.6543L7.96875 12.2685Z"
            fill="#EEEEF6"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.925 16.5642L11.955 16.5338L12.3267 15.5896L12.7441 16.5287L13.6918 16.6097L12.8384 17.1461L13.5267 18.0958L12.3326 17.6988L11.2976 18.1086L11.8442 17.1722L10.925 16.5642Z"
            fill="#EEEEF6"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.175 14.5642L14.205 14.5338L14.5767 13.5896L14.9941 14.5287L15.9418 14.6097L15.0884 15.1461L15.7767 16.0958L14.5826 15.6988L13.5476 16.1086L14.0942 15.1722L13.175 14.5642Z"
            fill="#EEEEF6"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.7194 2C23.7194 2 20.2445 2.6162 21.2197 6.90985H20.724C20.724 6.90985 20.7646 6.6858 20.2879 6.55443C19.8113 6.42306 19.9067 6.47238 19.6608 6.55443C19.4148 6.63648 17.9184 6.55443 17.9184 6.55443V6.71879L18.9773 7.12531C18.9773 7.12531 18.9512 7.4638 19.394 7.65137C19.8367 7.83894 20.1581 7.92933 20.1581 7.92933C20.1581 7.92933 20.2236 8.30286 19.8088 8.30286C19.394 8.30286 17.7255 7.82211 17.1321 9.00323C16.5387 10.1844 15.75 11.051 15.75 11.051H16.6398L16.401 11.3147H17.4029L17.1321 11.4514C17.1321 11.4514 18.3715 11.4391 18.4682 11.3147C18.5648 11.1903 18.4682 11.6519 18.4682 11.6519C18.4682 11.6519 19.6689 11.1646 19.7347 11.051L20.2951 11.3927L20.4548 10.8144L21.0561 11.051L21.2197 10.5C21.2197 10.5 22.9208 13.0288 24.211 12.8836V12.4639L25.3884 12.8836L25.5379 12.697C25.5379 12.697 26.9602 13.2125 27.398 13.2603L27.0857 12.697H27.398L27.0857 11.6519H27.398L26.7734 10.8144L26.9484 10.5876L26.8326 10.2896C26.8326 10.2896 29.1225 10.938 29.0192 11.9697C28.916 13.0013 27.8961 13.4176 27.8961 13.4176C27.8961 13.4176 26.9181 13.6839 26.0348 13.6266C26.0348 13.6266 26.736 14.3629 28.2197 14.1134C29.7033 13.8639 30.195 12.5852 30.195 12.5852C30.195 12.5852 30.8753 13.8412 30.3153 14.5016C29.7552 15.162 27.2617 15.6257 27.2617 15.6257C27.2617 15.6257 28.1638 16.0959 29.0192 15.9754C29.8746 15.8549 31.2049 15.1932 31.4628 14.1134C31.7206 13.0336 30.5731 11.0412 30.0532 10.8144L29.8479 10.1231L30.3153 10.2896L29.3563 8.20516L29.8213 8.29571L28.4646 6.79557L28.8381 6.69328L26.9638 5.49566L27.5247 5.36395C27.5247 5.36395 26.1392 4.73985 24.5588 5.49566L24.5738 5.23454L24.1585 5.29695L24.1831 5.00973L24.5958 4.45382L23.9762 4.24159C23.9762 4.24159 24.4771 3.57267 24.4019 3.58186C24.4019 3.58186 23.8436 3.72428 23.8753 3.66459C23.8753 3.66459 24.157 3.01991 24.0829 3.03717C24.0829 3.03717 23.4354 3.2329 23.5312 3.13495L23.7801 2.7411L23.7194 2Z"
            fill="#FBCD17"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124026">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default PapuaNewGuinea;
